import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Height } from '@mui/icons-material';
import "./addressModal.css";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "50rem",
    height: '40rem',
    bgcolor: 'background.paper',
    border: '',
    boxShadow: 24,
    p: 4,
};

const AddressModal = ({ open, handleClose, handleOpen }) => {
    const [age, setAge] = React.useState('');
    const handleChange = (event) => {
        setAge(event.target.value);
    };

    return (
        <div>

            <Modal
                open={open}
                
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" className='ad-title'>
                        Add New Address
                    </Typography>
                        <div className='flex select-box'>
                            <select
                                labelId=""
                                className='ad-select'
                                value={age}
                                label="age"
                                onChange={handleChange}
                                
                            >
                                <option value={10}>BillingAddress</option>
                                <option value={20}>ShippingAddress</option>
                            </select>
                        </div>
                        <div className='field-cover1'>
                       <label className='label-1'>Address 1</label>
                       <input className='lv1-right pl-1' />
                       <label className='label-2'>Address 2</label>
                       <input className='lv1-left pl-1' />
                        </div>
                        <div className='field-cover2'>
                       <label className='label-3'>City</label>
                       <input className='lv2-right pl-1' />
                       <label className='label-4'>State</label>
                       <input className='lv2-left pl-1' />
                        </div>
                        <div className='field-cover3'>
                       <label className='label-5'>Zip Code</label>
                       <input className='lv3-right pl-1' />
                       <label className='label-6'>Phone</label>
                       <input className='lv3-left pl-1' type='text'
                       />
                        </div>
                        <div className='lg:mt-[15rem] lg:ml-[15rem]'>
                        <Button
                            className="ad-cancel "
                            onClick={handleClose}
                            variant=""
                            type="submit"
                            sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "8rem", border: 'solid 1px', color: '#1976d2' }}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="ad-continue"
                            
                            variant=""
                            sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "8rem", marginLeft: "1rem", border: 'solid 1px', color: '#1976d2' }}
                        >
                            Continue
                        </Button>

                        </div>
                    {/* <div onClick={handleClose}>Close</div> */}
                </Box>
            </Modal>
        </div>
    )
}

export default AddressModal